import styled, { css } from "styled-components";

import React from "react";
import { connect } from "react-redux";
import { Button } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { reverse, routes } from "../../../routes";
import { withRouter } from "react-router";
import { UserMenuSection } from "./user";
import { SandboxNotice } from "./sandbox";
import RadiobuttonsSwitchCurrency from "../../../containers/common/switch-currency";

const HeaderLink = styled(Link)`
  font-size: 1.3em;
  font-size: min(3.5vw, 1.1em);
  font-weight: bold;
  margin: auto 1em;
`;

const overlayHeader = css`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  background-color: transparent;
  box-shadow: none;
  pointer-events: none;

  & > * {
    pointer-events: auto;
  }
`;

const StyledHeader = styled.div`
  align-items: center;
  background-color: #ffffff;
  box-shadow: 0 3px 9px 0 rgba(0, 0, 0, 0.1), 0 0 0 1px rgba(0, 0, 0, 0.04);
  ${({ $overlay }) => $overlay && overlayHeader}
`;

const StyledAppBar = styled.div`
  padding: 6px 10px;
  width: 100%;
  display: flex;
  min-height: 24px;
  justify-content: space-between;
  align-items: ${({ $overlay }) => ($overlay ? "center" : "baseline")};
  ${({ $overlay }) =>
    $overlay &&
    css`
      padding: 14px 22px;
      gap: 14px;
    `}
`;

const pillBg = css`
  position: relative;
  isolation: isolate;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);
  color: #fff;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: inherit;
    background: rgba(0, 0, 0, 0.32);
    backdrop-filter: blur(14px) saturate(140%);
    -webkit-backdrop-filter: blur(14px) saturate(140%);
    z-index: -1;
  }
`;

const StyledButton = styled(Button)`
  visibility: ${(props) => (props.hidden ? "hidden" : "visible")} !important;
  ${({ $overlay }) =>
    $overlay &&
    css`
      &.ui.button {
        ${pillBg};
        background: transparent !important;
        color: #fff !important;
        width: 40px;
        height: 40px;
        padding: 0 !important;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin: 0 !important;

        > i.icon {
          margin: 0 !important;
          color: #fff !important;
        }
      }
    `}
`;

const SectionBox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  ${({ $overlay }) =>
    $overlay &&
    css`
      ${pillBg};
      padding: 6px 12px 6px 14px;
      gap: 14px;

      .ui.dropdown .menu {
        position: absolute;
        top: calc(100% + 8px);
        right: 0;
        left: auto;
        transform: none;
        margin: 0;
        z-index: 20;
      }
    `}
`;

const StyledRadiobuttonsSwitchCurrency = styled(RadiobuttonsSwitchCurrency)`
  ${({ $overlay }) =>
    $overlay
      ? css`
          font-size: 14px;
          color: #fff;
        `
      : css`
          margin-right: 10px;
          font-size: 14px;
          padding: 4px 8px;
          border-radius: 999px;
          background: #fff;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08), 0 0 0 1.5px #e0e0e0;
        `}
`;

const BlockMenu = ({
  selected,
  sideMenuDocked,
  location,
  toggleVisibility,
  overlay,
}) => {
  const inBlock =
    selected &&
    location.pathname.startsWith(
      reverse(routes.blockBase, { blockId: selected.id })
    );

  return (
    <StyledHeader $overlay={overlay}>
      <StyledAppBar $overlay={overlay}>
        <StyledButton
          icon="content"
          onClick={toggleVisibility}
          hidden={sideMenuDocked}
          $overlay={overlay}
        />
        {inBlock && !overlay && (
          <HeaderLink
            to={reverse(routes.blockDetails, { blockId: selected.id })}
          >
            {selected.name}
          </HeaderLink>
        )}
        <SectionBox $overlay={overlay}>
          <SandboxNotice />
          <StyledRadiobuttonsSwitchCurrency $overlay={overlay} />
          <UserMenuSection />
        </SectionBox>
      </StyledAppBar>
    </StyledHeader>
  );
};

const mapStateToProps = (state) => ({
  blocks: state.blocks.entities,
  selected: state.blocks.selected,
});

export default withRouter(connect(mapStateToProps, () => ({}))(BlockMenu));
